export default {
	form: {
		optionalLabel: 'Valgfrit',
	},
} as const;
